<template>
  <div class="mb-4">

    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol col="2">
<!--            <img :src="'http://localhost:8081/staffs/'+profile.accounts.code+'/'+profile.accounts.code+'.png'"  alt="">-->
          </CCol>
          <CCol>
            <CRow>
              <CCol>
                <p class="mb-0"> <span class="font-weight-bold">{{ $t('staffID') }} : </span> {{ profileCode }} </p>
              </CCol>
              <CCol>
                <p class="mb-0 ">
                  <CRow>
                    <CCol class="font-weight-bold text-right"> <span> {{ $t('startDate') }}  : </span></CCol>
                    <CCol class="text-left" col="8"> <span>{{ startDateText }}</span></CCol>
                  </CRow>
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <p class="mb-0"> <span class="font-weight-bold">{{ $t('fullname') }} : </span> {{ fullName }} </p>
              </CCol>
              <CCol>
                <p class="mb-0 ">
                  <CRow>
                    <CCol class="font-weight-bold text-right"> <span>{{ $t('yearsOfService') }} : </span></CCol>
                    <CCol class="text-left" col="8"> <span>{{ workDuration }}</span></CCol>
                  </CRow>
                </p>
              </CCol>
            </CRow>


            <CRow>
              <CCol>
                <p class="mb-0"> <span class="font-weight-bold">{{ $t('position') }} : </span> {{ positionTitle }} </p>
              </CCol>
              <CCol>
                <p class="mb-0 ">
                  <CRow>
                    <CCol class="font-weight-bold text-right"> <span>{{ $t('staffTypes') }} : </span></CCol>
                    <CCol class="text-left" col="8"> <span>{{ staffTypeTitle }}</span></CCol>
                  </CRow>
                </p>
              </CCol>

            </CRow>

            <CRow>
              <CCol>
                <p class="mb-0"> <span class="font-weight-bold">{{ $t('department') }} : </span> {{ departmentTitle }} </p>
              </CCol>
              <CCol>
                <CRow>
                  <CCol class="font-weight-bold text-right"> <span>{{ $t('competencyLevel') }} : </span></CCol>
                  <CCol class="text-left" col="8"> <span> {{ competencyLevel }} </span></CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <p class="mb-0"> <span class="font-weight-bold">{{ $t('remark') }} : </span>  </p>
              </CCol>
            </CRow>


          </CCol>
        </CRow>

      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
moment.locale('th')

export default {
  name: 'Profile',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },
    fields: {
      type: Array,
      default() {
        return [
          // {key: "index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"avata", label:"", _style: 'width:50px; text-align: center'},
          {key:"members", label:"Member",  _style: 'width:200px;'},
          {key:"calss", label:"Class Info",},
          {key:"dateTime", label:"Last Update",  _style: 'width:190px;'},
          // {key:"action", label: "#"}
          // {key:"attend", label:"Attend Class",  _style: 'width:200px; text-align: center'}
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,


    profile:{
      type: Object,
      default() {
        return {}
      }
    }
  },

  data: function () {
    return {

      collapseDuration: 0,
      isDialog: false,
      method: [],



    }
  },

  mounted() {
  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {

      moment.locale('en')
      this.onLoad();
    },

    onLoad() {

    },

    resolveLocalizedValue(items) {
      if (!Array.isArray(items) || items.length === 0) {
        return "";
      }

      return (
        items.find((obj) => obj.key == this.lang)?.value ||
        items[0]?.value ||
        ""
      );
    },

    onCheckLevel(data) {
      if (!Array.isArray(data) || data.length === 0) {
        return 1;
      }

      var level = 1;
      var objs = this.onCheckLastFields(data)
      if(objs.type && objs.type.control != null){
        const start = moment(objs.startDate);
        const end =  moment().set("month",8).set("date",30).add(-2,"years"); // หากไม่มี endDate ให้ใช้วันที่ปัจจุบัน

        const years = end.diff(start, 'years');
        const levelConfig = objs.type.control.filter((item) => {
          return (item.year >= years)}
        )[0]
        level = levelConfig ? levelConfig.level : level
      }

      if(objs.work && objs.work.control != null){
        level= objs.work.control[objs.work.control.length-1].level;
      }

      if(objs.name && objs.name.control != null){
        level = objs.name.control[objs.name.control.length-1].level;
      }
      return level;
    },
    onCheckLastFields(item){
      if (!Array.isArray(item) || item.length === 0) {
        return {}
      }
      return item[item.length-1]
    },

    onDateStarteWork(value){
      if (!Array.isArray(value) || value.length === 0 || !value[value.length-1]?.startDate) {
        return "";
      }
      return moment(value[value.length-1].startDate).format('DD MMMM') + ' ' + (moment(value[value.length-1].startDate).year() + 543);
    },

    calculateWorkDuration(startDate, endDate) {
      if (!Array.isArray(startDate) || startDate.length === 0 || !startDate[startDate.length-1]?.startDate) {
        return "";
      }

      const start = moment(startDate[startDate.length-1].startDate);
      const end = endDate ? moment(endDate) : moment(); // หากไม่มี endDate ให้ใช้วันที่ปัจจุบัน

      const years = end.diff(start, 'years');
      start.add(years, 'years');

      const months = end.diff(start, 'months');
      start.add(months, 'months');

      const days = end.diff(start, 'days');

      return `${years} `+this.$t('year')+` ${months} `+this.$t('months')+` ${days} `+this.$t('days');
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    }),

    profileAccounts() {
      return this.profile && this.profile.accounts ? this.profile.accounts : {};
    },

    profileUserinfo() {
      return this.profileAccounts.userinfo || {};
    },

    profilePositions() {
      return Array.isArray(this.profile && this.profile.positions) ? this.profile.positions : [];
    },

    latestPosition() {
      return this.onCheckLastFields(this.profilePositions);
    },

    profileCode() {
      return this.profileAccounts.code || "";
    },

    fullName() {
      return [
        this.resolveLocalizedValue(this.profileUserinfo.prefix),
        this.resolveLocalizedValue(this.profileUserinfo.firstName),
        this.resolveLocalizedValue(this.profileUserinfo.lastName)
      ].filter(Boolean).join(" ");
    },

    startDateText() {
      return this.onDateStarteWork(this.profilePositions);
    },

    workDuration() {
      return this.calculateWorkDuration(this.profilePositions, null);
    },

    positionTitle() {
      return this.resolveLocalizedValue(this.latestPosition.name && this.latestPosition.name.title);
    },

    staffTypeTitle() {
      return this.resolveLocalizedValue(this.latestPosition.type && this.latestPosition.type.title);
    },

    departmentTitle() {
      return this.resolveLocalizedValue(this.latestPosition.agency && this.latestPosition.agency.title);
    },

    competencyLevel() {
      return this.onCheckLevel(this.profilePositions);
    }
  },

  watch: {
    lang(value){
      moment.locale(value)
    }
  }
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
